import { ShippingRateResponses } from '@/types/ShippingRateResponses';

class ShippingEstimatorDTO {
  private shippingRateResponses: ShippingRateResponses;

  constructor(shippingRates: ShippingRateResponses, freeSHTotalRetail?: number) {
    this.shippingRateResponses = shippingRates;
    this.shippingRateResponses.shippingErrorPopUpMessage = this.convertShippingErrorMessage(
      this.shippingRateResponses.shippingErrorPopUpMessage,
    );
    if (
      freeSHTotalRetail &&
      this.shippingRateResponses.shippingMessageResponse &&
      this.shippingRateResponses.shippingMessageResponse.message?.toLowerCase().includes('free')
    ) {
      this.shippingRateResponses.shippingMessageResponse.popUpMessage = this.convertFreeShippingPopupMessage(
        this.shippingRateResponses.shippingMessageResponse.popUpMessage,
        freeSHTotalRetail
      );
    }
  }

  public get getShippingRateResponses(): ShippingRateResponses {
    return this.shippingRateResponses;
  }

  private convertShippingErrorMessage(htmlContent: string | null): string | null {
    if (!htmlContent) return null;
    const startTag = '<div id="unableToShip"';
    const endTag = '</div>';
    const startIndex = htmlContent.indexOf(startTag);
    const endIndex = htmlContent.indexOf(endTag, startIndex) + endTag.length;
    const unableToShipDiv = htmlContent.substring(startIndex, endIndex);
    return unableToShipDiv;
  }

  private convertFreeShippingPopupMessage(
    content: string | null | undefined,
    freeSHTotalRetail: number,
  ): string | null {
    if (!content) return null;
    const stringWithChangedPrice = content.replace(/\$+\d+(?:\.\d{1,2})?/g, `$${freeSHTotalRetail}`);
    return stringWithChangedPrice;
  }
}

export default ShippingEstimatorDTO;
